import { render, staticRenderFns } from "./EventInfoDialog.vue?vue&type=template&id=4eea2589&scoped=true"
import script from "./EventInfoDialog.vue?vue&type=script&lang=ts"
export * from "./EventInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./EventInfoDialog.vue?vue&type=style&index=0&id=4eea2589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea2589",
  null
  
)

export default component.exports